/**
 * @generated SignedSource<<e22f3ec1ecf428a0e13052a7182b5ddb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_viewer$data = {
  readonly shareJewelryItemTooltip?: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbleShare_viewer" | "PdpSharedIconBubbleEmail_viewer">;
  readonly " $fragmentType": "PdpRespIconBubbles_viewer";
};
export type PdpRespIconBubbles_viewer$key = {
  readonly " $data"?: PdpRespIconBubbles_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespIconBubbles_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespIconBubbles_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_viewer"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "shareJewelryItemTooltip",
          "args": [
            {
              "kind": "Literal",
              "name": "feature",
              "value": "shareJewelryItemTooltip"
            }
          ],
          "kind": "ScalarField",
          "name": "featureFlag",
          "storageKey": "featureFlag(feature:\"shareJewelryItemTooltip\")"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubbleShare_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a106e953a279ac73d3800a75291a7c10";

export default node;
